export default __webpack_public_path__ + "static/tip2-a793a40820896b5fdc5ca83739a0b7a0.png";